import React from "react";
import TextField from "../Fields/text-field";
import DropdownField from "../Fields/dropdown-field";
import RangeField from "../Fields/range-field";

export default class SearchForm extends React.Component {
    constructor(props) {
        super(props);

        const mapFieldToAspect = (field) => field.name;
        this.primaryFieldAspects = props.primaryFields.map(mapFieldToAspect);
        this.secondaryFieldAspects = props.secondaryFields.map(mapFieldToAspect);

        this.buildState = this.buildState.bind(this);
        this.onServerResponse = this.onServerResponse.bind(this);
        this.handleFieldUpdated = this.handleFieldUpdated.bind(this);
        this.renderField = this.renderField.bind(this);

        this.state = this.buildState(props);
    }

    buildState(source) {
        return ({
            heading: source.heading,
            subHeading: source.subHeading,
            primaryFields: source.primaryFields,
            secondaryFields: source.secondaryFields,
            searchButtonUrl: source.searchButtonUrl,
            searchButtonText: source.searchButtonText,
            expression: source.expression,
            disableSearch: source.disableSearch,
            forceDisable: false
        });
    }

    onServerResponse(xhr) {
        if (!xhr.responseText || xhr.status !== 200) return;

        var serverResponse = JSON.parse(xhr.responseText);
        this.setState(this.buildState(serverResponse));
    }

    handleFieldUpdated(fieldData) {
        if (this.state.expression === fieldData.value && !fieldData.force) return;

        this.setState({ forceDisable: true, expression: fieldData.value });
        var xhr = new XMLHttpRequest();
        xhr.addEventListener("load", () => this.onServerResponse(xhr));
        xhr.open("POST", `/_homepage/v1/search/?tenantName=${this.props.tenant}`);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify({ expression: fieldData.value }));
    }

    onExpressionUpdate(newExpression) {
        // update button url with best guess for non-seo listings page
        // api will return correct url, this is to patch the delay
        var btnUrl = this.props.searchUrl;
        if (!btnUrl) return;
        btnUrl = btnUrl.trim();
        btnUrl = btnUrl.startsWith("/") ? btnUrl : "/" + btnUrl;
        btnUrl = btnUrl.endsWith("/") ? btnUrl : btnUrl + "/";
        this.setState({ expression: newExpression, searchButtonUrl: `${btnUrl}?q=${newExpression}` });
    }

    renderField(fieldData) {
        const props = { key: fieldData.name, disable: this.state.forceDisable, onFieldUpdated: this.handleFieldUpdated };
        switch (fieldData.type) {
            case "text":
                return (<TextField {...props} {...fieldData} onExpressionUpdate={this.onExpressionUpdate.bind(this)} />);
            case "dropdown":
                return (<DropdownField {...props} {...fieldData} />);
            case "range":
                return (<RangeField {...props} {...fieldData} />);
            default:
                return null;
        }
    }

    render() {
        var onclick = this.state.disableSearch ? e => e.preventDefault() : null;
        var showSubHeading = this.state.subHeading && this.state.subHeading.length;
        var searchBtnClasses = "search-form-submit text-white";
        if (!this.state.disableSearch) searchBtnClasses += " bg-primary";

        return (
            <div className="fadein">
                <div className="fields-wrapper fields-wrapper-primary">
                    {this.state.primaryFields.map(this.renderField)}
                    <a className={searchBtnClasses} href={this.state.searchButtonUrl}
                        disabled={this.state.disableSearch} onClick={onclick} data-webm-clickvalue="search"
                        data-opm-trackon="click" data-opm-event="click-search-button-homepage">
                        <span>{this.state.searchButtonText}</span>
                    </a>
                </div>
                <div className="search-form-bottom">
                    <div className="fields-wrapper fields-wrapper-secondary">
                        {this.state.secondaryFields.map(this.renderField)}
                    </div>
                    {showSubHeading && <h6 className="sub-heading">{this.state.subHeading}</h6>}
                    {this.props.otherLinkUrl && this.props.otherLinkText &&
                        <a className="other-link" href={this.props.otherLinkUrl}>{this.props.otherLinkText}</a>}
                </div>
            </div>
        );
    }
};
